import { useState } from 'react'

export const useWheelGame = () => {
  // 转盘转动状态
  const [isSpinning, setIsSpinning] = useState(false)
  // 转动结果
  const [result, setResult] = useState(null)
  // 配置面板显示状态
  const [showConfig, setShowConfig] = useState(false)

  // 开始转动
  const handleSpin = () => {
    if (isSpinning) return
    setIsSpinning(true)
    setResult(null)
  }

  // 转动完成
  const handleSpinComplete = (newResult) => {
    setResult(newResult)
    setIsSpinning(false)
  }

  // 关闭结果弹窗
  const handleCloseResult = () => {
    setResult(null)
  }

  // 切换配置面板
  const toggleConfig = () => {
    if (!isSpinning) {
      setShowConfig(prev => !prev)
    }
  }

  return {
    isSpinning,
    result,
    showConfig,
    handleSpin,
    handleSpinComplete,
    handleCloseResult,
    toggleConfig,
    setShowConfig
  }
}



